export const AUTHENTICATION_FAILED = 'JWT_AUTHENTICATION_FAILED';
export const REFRESH_TOKEN_HEADER = 'X-BondUserRefreshToken';
export const ACCESS_TOKEN_HEADER = 'X-BondUserAccessToken';
export const ID_TOKEN_HEADER = 'X-BondUserIdToken';
export const USERNAME_HEADER = 'X-BondUserUsername';
